export interface Country {
  name: string;
  code: string;
  flag: string;
  phoneCode: string;
}

export const COUNTRIES: Country[] = [
  // Original 5 countries
  {
    name: "Brasil",
    code: "BR",
    flag: "🇧🇷",
    phoneCode: "+55"
  },
  {
    name: "Portugal",
    code: "PT",
    flag: "🇵🇹",
    phoneCode: "+351"
  },
  {
    name: "Estados Unidos",
    code: "US",
    flag: "🇺🇸",
    phoneCode: "+1"
  },
  {
    name: "Argentina",
    code: "AR",
    flag: "🇦🇷",
    phoneCode: "+54"
  },
  {
    name: "México",
    code: "MX",
    flag: "🇲🇽",
    phoneCode: "+52"
  },
  // Europe
  {
    name: "Espanha",
    code: "ES",
    flag: "🇪🇸",
    phoneCode: "+34"
  },
  {
    name: "França",
    code: "FR",
    flag: "🇫🇷",
    phoneCode: "+33"
  },
  {
    name: "Alemanha",
    code: "DE",
    flag: "🇩🇪",
    phoneCode: "+49"
  },
  {
    name: "Itália",
    code: "IT",
    flag: "🇮🇹",
    phoneCode: "+39"
  },
  {
    name: "Reino Unido",
    code: "GB",
    flag: "🇬🇧",
    phoneCode: "+44"
  },
  {
    name: "Países Baixos",
    code: "NL",
    flag: "🇳🇱",
    phoneCode: "+31"
  },
  {
    name: "Bélgica",
    code: "BE",
    flag: "🇧🇪",
    phoneCode: "+32"
  },
  {
    name: "Suíça",
    code: "CH",
    flag: "🇨🇭",
    phoneCode: "+41"
  },
  {
    name: "Áustria",
    code: "AT",
    flag: "🇦🇹",
    phoneCode: "+43"
  },
  {
    name: "Suécia",
    code: "SE",
    flag: "🇸🇪",
    phoneCode: "+46"
  },
  {
    name: "Noruega",
    code: "NO",
    flag: "🇳🇴",
    phoneCode: "+47"
  },
  {
    name: "Dinamarca",
    code: "DK",
    flag: "🇩🇰",
    phoneCode: "+45"
  },
  {
    name: "Finlândia",
    code: "FI",
    flag: "🇫🇮",
    phoneCode: "+358"
  },
  {
    name: "Irlanda",
    code: "IE",
    flag: "🇮🇪",
    phoneCode: "+353"
  },
  {
    name: "Polônia",
    code: "PL",
    flag: "🇵🇱",
    phoneCode: "+48"
  },
  {
    name: "Rússia",
    code: "RU",
    flag: "🇷🇺",
    phoneCode: "+7"
  },
  {
    name: "Ucrânia",
    code: "UA",
    flag: "🇺🇦",
    phoneCode: "+380"
  },
  {
    name: "República Tcheca",
    code: "CZ",
    flag: "🇨🇿",
    phoneCode: "+420"
  },
  {
    name: "Hungria",
    code: "HU",
    flag: "🇭🇺",
    phoneCode: "+36"
  },
  {
    name: "Romênia",
    code: "RO",
    flag: "🇷🇴",
    phoneCode: "+40"
  },
  {
    name: "Bulgária",
    code: "BG",
    flag: "🇧🇬",
    phoneCode: "+359"
  },
  {
    name: "Grécia",
    code: "GR",
    flag: "🇬🇷",
    phoneCode: "+30"
  },
  {
    name: "Croácia",
    code: "HR",
    flag: "🇭🇷",
    phoneCode: "+385"
  },
  {
    name: "Sérvia",
    code: "RS",
    flag: "🇷🇸",
    phoneCode: "+381"
  },
  {
    name: "Eslováquia",
    code: "SK",
    flag: "🇸🇰",
    phoneCode: "+421"
  },
  {
    name: "Eslovênia",
    code: "SI",
    flag: "🇸🇮",
    phoneCode: "+386"
  },
  {
    name: "Lituânia",
    code: "LT",
    flag: "🇱🇹",
    phoneCode: "+370"
  },
  {
    name: "Letônia",
    code: "LV",
    flag: "🇱🇻",
    phoneCode: "+371"
  },
  {
    name: "Estônia",
    code: "EE",
    flag: "🇪🇪",
    phoneCode: "+372"
  },
  {
    name: "Islândia",
    code: "IS",
    flag: "🇮🇸",
    phoneCode: "+354"
  },
  {
    name: "Luxemburgo",
    code: "LU",
    flag: "🇱🇺",
    phoneCode: "+352"
  },
  {
    name: "Malta",
    code: "MT",
    flag: "🇲🇹",
    phoneCode: "+356"
  },
  {
    name: "Chipre",
    code: "CY",
    flag: "🇨🇾",
    phoneCode: "+357"
  },
  // Americas
  {
    name: "Canadá",
    code: "CA",
    flag: "🇨🇦",
    phoneCode: "+1"
  },
  {
    name: "Chile",
    code: "CL",
    flag: "🇨🇱",
    phoneCode: "+56"
  },
  {
    name: "Colômbia",
    code: "CO",
    flag: "🇨🇴",
    phoneCode: "+57"
  },
  {
    name: "Peru",
    code: "PE",
    flag: "🇵🇪",
    phoneCode: "+51"
  },
  {
    name: "Uruguai",
    code: "UY",
    flag: "🇺🇾",
    phoneCode: "+598"
  },
  {
    name: "Paraguai",
    code: "PY",
    flag: "🇵🇾",
    phoneCode: "+595"
  },
  {
    name: "Bolívia",
    code: "BO",
    flag: "🇧🇴",
    phoneCode: "+591"
  },
  {
    name: "Equador",
    code: "EC",
    flag: "🇪🇨",
    phoneCode: "+593"
  },
  {
    name: "Venezuela",
    code: "VE",
    flag: "🇻🇪",
    phoneCode: "+58"
  },
  {
    name: "Guiana",
    code: "GY",
    flag: "🇬🇾",
    phoneCode: "+592"
  },
  {
    name: "Suriname",
    code: "SR",
    flag: "🇸🇷",
    phoneCode: "+597"
  },
  {
    name: "Guiana Francesa",
    code: "GF",
    flag: "🇬🇫",
    phoneCode: "+594"
  },
  {
    name: "Costa Rica",
    code: "CR",
    flag: "🇨🇷",
    phoneCode: "+506"
  },
  {
    name: "Panamá",
    code: "PA",
    flag: "🇵🇦",
    phoneCode: "+507"
  },
  {
    name: "Nicarágua",
    code: "NI",
    flag: "🇳🇮",
    phoneCode: "+505"
  },
  {
    name: "Honduras",
    code: "HN",
    flag: "🇭🇳",
    phoneCode: "+504"
  },
  {
    name: "El Salvador",
    code: "SV",
    flag: "🇸🇻",
    phoneCode: "+503"
  },
  {
    name: "Guatemala",
    code: "GT",
    flag: "🇬🇹",
    phoneCode: "+502"
  },
  {
    name: "Belize",
    code: "BZ",
    flag: "🇧🇿",
    phoneCode: "+501"
  },
  {
    name: "Cuba",
    code: "CU",
    flag: "🇨🇺",
    phoneCode: "+53"
  },
  {
    name: "Jamaica",
    code: "JM",
    flag: "🇯🇲",
    phoneCode: "+1876"
  },
  {
    name: "Haiti",
    code: "HT",
    flag: "🇭🇹",
    phoneCode: "+509"
  },
  {
    name: "República Dominicana",
    code: "DO",
    flag: "🇩🇴",
    phoneCode: "+1809"
  },
  {
    name: "Porto Rico",
    code: "PR",
    flag: "🇵🇷",
    phoneCode: "+1787"
  },
  {
    name: "Trinidad e Tobago",
    code: "TT",
    flag: "🇹🇹",
    phoneCode: "+1868"
  },
  {
    name: "Barbados",
    code: "BB",
    flag: "🇧🇧",
    phoneCode: "+1246"
  },
  {
    name: "Bahamas",
    code: "BS",
    flag: "🇧🇸",
    phoneCode: "+1242"
  },
  // Asia
  {
    name: "Japão",
    code: "JP",
    flag: "🇯🇵",
    phoneCode: "+81"
  },
  {
    name: "China",
    code: "CN",
    flag: "🇨🇳",
    phoneCode: "+86"
  },
  {
    name: "Coreia do Sul",
    code: "KR",
    flag: "🇰🇷",
    phoneCode: "+82"
  },
  {
    name: "Índia",
    code: "IN",
    flag: "🇮🇳",
    phoneCode: "+91"
  },
  {
    name: "Coreia do Norte",
    code: "KP",
    flag: "🇰🇵",
    phoneCode: "+850"
  },
  {
    name: "Mongólia",
    code: "MN",
    flag: "🇲🇳",
    phoneCode: "+976"
  },
  {
    name: "Taiwan",
    code: "TW",
    flag: "🇹🇼",
    phoneCode: "+886"
  },
  {
    name: "Hong Kong",
    code: "HK",
    flag: "🇭🇰",
    phoneCode: "+852"
  },
  {
    name: "Macau",
    code: "MO",
    flag: "🇲🇴",
    phoneCode: "+853"
  },
  {
    name: "Singapura",
    code: "SG",
    flag: "🇸🇬",
    phoneCode: "+65"
  },
  {
    name: "Malásia",
    code: "MY",
    flag: "🇲🇾",
    phoneCode: "+60"
  },
  {
    name: "Tailândia",
    code: "TH",
    flag: "🇹🇭",
    phoneCode: "+66"
  },
  {
    name: "Vietnã",
    code: "VN",
    flag: "🇻🇳",
    phoneCode: "+84"
  },
  {
    name: "Camboja",
    code: "KH",
    flag: "🇰🇭",
    phoneCode: "+855"
  },
  {
    name: "Laos",
    code: "LA",
    flag: "🇱🇦",
    phoneCode: "+856"
  },
  {
    name: "Myanmar",
    code: "MM",
    flag: "🇲🇲",
    phoneCode: "+95"
  },
  {
    name: "Bangladesh",
    code: "BD",
    flag: "🇧🇩",
    phoneCode: "+880"
  },
  {
    name: "Sri Lanka",
    code: "LK",
    flag: "🇱🇰",
    phoneCode: "+94"
  },
  {
    name: "Nepal",
    code: "NP",
    flag: "🇳🇵",
    phoneCode: "+977"
  },
  {
    name: "Butão",
    code: "BT",
    flag: "🇧🇹",
    phoneCode: "+975"
  },
  {
    name: "Paquistão",
    code: "PK",
    flag: "🇵🇰",
    phoneCode: "+92"
  },
  {
    name: "Afeganistão",
    code: "AF",
    flag: "🇦🇫",
    phoneCode: "+93"
  },
  {
    name: "Irã",
    code: "IR",
    flag: "🇮🇷",
    phoneCode: "+98"
  },
  {
    name: "Iraque",
    code: "IQ",
    flag: "🇮🇶",
    phoneCode: "+964"
  },
  {
    name: "Kuwait",
    code: "KW",
    flag: "🇰🇼",
    phoneCode: "+965"
  },
  {
    name: "Arábia Saudita",
    code: "SA",
    flag: "🇸🇦",
    phoneCode: "+966"
  },
  {
    name: "Emirados Árabes Unidos",
    code: "AE",
    flag: "🇦🇪",
    phoneCode: "+971"
  },
  {
    name: "Qatar",
    code: "QA",
    flag: "🇶🇦",
    phoneCode: "+974"
  },
  {
    name: "Bahrain",
    code: "BH",
    flag: "🇧🇭",
    phoneCode: "+973"
  },
  {
    name: "Omã",
    code: "OM",
    flag: "🇴🇲",
    phoneCode: "+968"
  },
  {
    name: "Iêmen",
    code: "YE",
    flag: "🇾🇪",
    phoneCode: "+967"
  },
  {
    name: "Jordânia",
    code: "JO",
    flag: "🇯🇴",
    phoneCode: "+962"
  },
  {
    name: "Líbano",
    code: "LB",
    flag: "🇱🇧",
    phoneCode: "+961"
  },
  {
    name: "Síria",
    code: "SY",
    flag: "🇸🇾",
    phoneCode: "+963"
  },
  {
    name: "Israel",
    code: "IL",
    flag: "🇮🇱",
    phoneCode: "+972"
  },
  {
    name: "Palestina",
    code: "PS",
    flag: "🇵🇸",
    phoneCode: "+970"
  },
  {
    name: "Turquia",
    code: "TR",
    flag: "🇹🇷",
    phoneCode: "+90"
  },
  {
    name: "Geórgia",
    code: "GE",
    flag: "🇬🇪",
    phoneCode: "+995"
  },
  {
    name: "Armênia",
    code: "AM",
    flag: "🇦🇲",
    phoneCode: "+374"
  },
  {
    name: "Azerbaijão",
    code: "AZ",
    flag: "🇦🇿",
    phoneCode: "+994"
  },
  {
    name: "Cazaquistão",
    code: "KZ",
    flag: "🇰🇿",
    phoneCode: "+7"
  },
  {
    name: "Uzbequistão",
    code: "UZ",
    flag: "🇺🇿",
    phoneCode: "+998"
  },
  {
    name: "Quirguistão",
    code: "KG",
    flag: "🇰🇬",
    phoneCode: "+996"
  },
  {
    name: "Tajiquistão",
    code: "TJ",
    flag: "🇹🇯",
    phoneCode: "+992"
  },
  {
    name: "Turcomenistão",
    code: "TM",
    flag: "🇹🇲",
    phoneCode: "+993"
  },
  {
    name: "Filipinas",
    code: "PH",
    flag: "🇵🇭",
    phoneCode: "+63"
  },
  {
    name: "Indonésia",
    code: "ID",
    flag: "🇮🇩",
    phoneCode: "+62"
  },
  {
    name: "Brunei",
    code: "BN",
    flag: "🇧🇳",
    phoneCode: "+673"
  },
  {
    name: "Timor-Leste",
    code: "TL",
    flag: "🇹🇱",
    phoneCode: "+670"
  },
  {
    name: "Papua-Nova Guiné",
    code: "PG",
    flag: "🇵🇬",
    phoneCode: "+675"
  },
  {
    name: "Fiji",
    code: "FJ",
    flag: "🇫🇯",
    phoneCode: "+679"
  },
  {
    name: "Vanuatu",
    code: "VU",
    flag: "🇻🇺",
    phoneCode: "+678"
  },
  {
    name: "Nova Caledônia",
    code: "NC",
    flag: "🇳🇨",
    phoneCode: "+687"
  },
  {
    name: "Ilhas Salomão",
    code: "SB",
    flag: "🇸🇧",
    phoneCode: "+677"
  },
  {
    name: "Samoa",
    code: "WS",
    flag: "🇼🇸",
    phoneCode: "+685"
  },
  {
    name: "Tonga",
    code: "TO",
    flag: "🇹🇴",
    phoneCode: "+676"
  },
  {
    name: "Kiribati",
    code: "KI",
    flag: "🇰🇮",
    phoneCode: "+686"
  },
  {
    name: "Tuvalu",
    code: "TV",
    flag: "🇹🇻",
    phoneCode: "+688"
  },
  {
    name: "Nauru",
    code: "NR",
    flag: "🇳🇷",
    phoneCode: "+674"
  },
  {
    name: "Palau",
    code: "PW",
    flag: "🇵🇼",
    phoneCode: "+680"
  },
  {
    name: "Micronésia",
    code: "FM",
    flag: "🇫🇲",
    phoneCode: "+691"
  },
  {
    name: "Ilhas Marshall",
    code: "MH",
    flag: "🇲🇭",
    phoneCode: "+692"
  },
  // Oceania
  {
    name: "Austrália",
    code: "AU",
    flag: "🇦🇺",
    phoneCode: "+61"
  },
  {
    name: "Nova Zelândia",
    code: "NZ",
    flag: "🇳🇿",
    phoneCode: "+64"
  },
  // Africa
  {
    name: "África do Sul",
    code: "ZA",
    flag: "🇿🇦",
    phoneCode: "+27"
  },
  {
    name: "Nigéria",
    code: "NG",
    flag: "🇳🇬",
    phoneCode: "+234"
  },
  {
    name: "Egito",
    code: "EG",
    flag: "🇪🇬",
    phoneCode: "+20"
  },
  {
    name: "Marrocos",
    code: "MA",
    flag: "🇲🇦",
    phoneCode: "+212"
  },
  {
    name: "Argélia",
    code: "DZ",
    flag: "🇩🇿",
    phoneCode: "+213"
  },
  {
    name: "Tunísia",
    code: "TN",
    flag: "🇹🇳",
    phoneCode: "+216"
  },
  {
    name: "Líbia",
    code: "LY",
    flag: "🇱🇾",
    phoneCode: "+218"
  },
  {
    name: "Sudão",
    code: "SD",
    flag: "🇸🇩",
    phoneCode: "+249"
  },
  {
    name: "Sudão do Sul",
    code: "SS",
    flag: "🇸🇸",
    phoneCode: "+211"
  },
  {
    name: "Etiópia",
    code: "ET",
    flag: "🇪🇹",
    phoneCode: "+251"
  },
  {
    name: "Somália",
    code: "SO",
    flag: "🇸🇴",
    phoneCode: "+252"
  },
  {
    name: "Djibouti",
    code: "DJ",
    flag: "🇩🇯",
    phoneCode: "+253"
  },
  {
    name: "Eritreia",
    code: "ER",
    flag: "🇪🇷",
    phoneCode: "+291"
  },
  {
    name: "Quênia",
    code: "KE",
    flag: "🇰🇪",
    phoneCode: "+254"
  },
  {
    name: "Tanzânia",
    code: "TZ",
    flag: "🇹🇿",
    phoneCode: "+255"
  },
  {
    name: "Uganda",
    code: "UG",
    flag: "🇺🇬",
    phoneCode: "+256"
  },
  {
    name: "Ruanda",
    code: "RW",
    flag: "🇷🇼",
    phoneCode: "+250"
  },
  {
    name: "Burundi",
    code: "BI",
    flag: "🇧🇮",
    phoneCode: "+257"
  },
  {
    name: "República Democrática do Congo",
    code: "CD",
    flag: "🇨🇩",
    phoneCode: "+243"
  },
  {
    name: "República do Congo",
    code: "CG",
    flag: "🇨🇬",
    phoneCode: "+242"
  },
  {
    name: "Gabão",
    code: "GA",
    flag: "🇬🇦",
    phoneCode: "+241"
  },
  {
    name: "Camarões",
    code: "CM",
    flag: "🇨🇲",
    phoneCode: "+237"
  },
  {
    name: "Chade",
    code: "TD",
    flag: "🇹🇩",
    phoneCode: "+235"
  },
  {
    name: "República Centro-Africana",
    code: "CF",
    flag: "🇨🇫",
    phoneCode: "+236"
  },
  {
    name: "Guiné Equatorial",
    code: "GQ",
    flag: "🇬🇶",
    phoneCode: "+240"
  },
  {
    name: "São Tomé e Príncipe",
    code: "ST",
    flag: "🇸🇹",
    phoneCode: "+239"
  },
  {
    name: "Angola",
    code: "AO",
    flag: "🇦🇴",
    phoneCode: "+244"
  },
  {
    name: "Zâmbia",
    code: "ZM",
    flag: "🇿🇲",
    phoneCode: "+260"
  },
  {
    name: "Zimbábue",
    code: "ZW",
    flag: "🇿🇼",
    phoneCode: "+263"
  },
  {
    name: "Malawi",
    code: "MW",
    flag: "🇲🇼",
    phoneCode: "+265"
  },
  {
    name: "Moçambique",
    code: "MZ",
    flag: "🇲🇿",
    phoneCode: "+258"
  },
  {
    name: "Namíbia",
    code: "NA",
    flag: "🇳🇦",
    phoneCode: "+264"
  },
  {
    name: "Botswana",
    code: "BW",
    flag: "🇧🇼",
    phoneCode: "+267"
  },
  {
    name: "Lesoto",
    code: "LS",
    flag: "🇱🇸",
    phoneCode: "+266"
  },
  {
    name: "Eswatini",
    code: "SZ",
    flag: "🇸🇿",
    phoneCode: "+268"
  },
  {
    name: "Madagascar",
    code: "MG",
    flag: "🇲🇬",
    phoneCode: "+261"
  },
  {
    name: "Comores",
    code: "KM",
    flag: "🇰🇲",
    phoneCode: "+269"
  },
  {
    name: "Maurício",
    code: "MU",
    flag: "🇲🇺",
    phoneCode: "+230"
  },
  {
    name: "Seychelles",
    code: "SC",
    flag: "🇸🇨",
    phoneCode: "+248"
  },
  {
    name: "Mali",
    code: "ML",
    flag: "🇲🇱",
    phoneCode: "+223"
  },
  {
    name: "Burkina Faso",
    code: "BF",
    flag: "🇧🇫",
    phoneCode: "+226"
  },
  {
    name: "Níger",
    code: "NE",
    flag: "🇳🇪",
    phoneCode: "+227"
  },
  {
    name: "Senegal",
    code: "SN",
    flag: "🇸🇳",
    phoneCode: "+221"
  },
  {
    name: "Gâmbia",
    code: "GM",
    flag: "🇬🇲",
    phoneCode: "+220"
  },
  {
    name: "Guiné-Bissau",
    code: "GW",
    flag: "🇬🇼",
    phoneCode: "+245"
  },
  {
    name: "Guiné",
    code: "GN",
    flag: "🇬🇳",
    phoneCode: "+224"
  },
  {
    name: "Serra Leoa",
    code: "SL",
    flag: "🇸🇱",
    phoneCode: "+232"
  },
  {
    name: "Libéria",
    code: "LR",
    flag: "🇱🇷",
    phoneCode: "+231"
  },
  {
    name: "Costa do Marfim",
    code: "CI",
    flag: "🇨🇮",
    phoneCode: "+225"
  },
  {
    name: "Gana",
    code: "GH",
    flag: "🇬🇭",
    phoneCode: "+233"
  },
  {
    name: "Togo",
    code: "TG",
    flag: "🇹🇬",
    phoneCode: "+228"
  },
  {
    name: "Benin",
    code: "BJ",
    flag: "🇧🇯",
    phoneCode: "+229"
  },
  {
    name: "Cabo Verde",
    code: "CV",
    flag: "🇨🇻",
    phoneCode: "+238"
  },
  {
    name: "Mauritânia",
    code: "MR",
    flag: "🇲🇷",
    phoneCode: "+222"
  }
];

// Legacy country codes mapping for backward compatibility
export const COUNTRY_CODES: Record<string, string> = {
  "Brasil": "+55",
  "Portugal": "+351",
  "Estados Unidos": "+1",
  "Argentina": "+54",
  "México": "+52",
  "Espanha": "+34",
  "França": "+33",
  "Alemanha": "+49",
  "Itália": "+39",
  "Reino Unido": "+44",
  "Países Baixos": "+31",
  "Bélgica": "+32",
  "Suíça": "+41",
  "Áustria": "+43",
  "Suécia": "+46",
  "Noruega": "+47",
  "Dinamarca": "+45",
  "Finlândia": "+358",
  "Irlanda": "+353",
  "Polônia": "+48",
  "Rússia": "+7",
  "Ucrânia": "+380",
  "República Tcheca": "+420",
  "Hungria": "+36",
  "Romênia": "+40",
  "Bulgária": "+359",
  "Grécia": "+30",
  "Croácia": "+385",
  "Sérvia": "+381",
  "Eslováquia": "+421",
  "Eslovênia": "+386",
  "Lituânia": "+370",
  "Letônia": "+371",
  "Estônia": "+372",
  "Islândia": "+354",
  "Luxemburgo": "+352",
  "Malta": "+356",
  "Chipre": "+357",
  "Canadá": "+1",
  "Chile": "+56",
  "Colômbia": "+57",
  "Peru": "+51",
  "Uruguai": "+598",
  "Paraguai": "+595",
  "Bolívia": "+591",
  "Equador": "+593",
  "Venezuela": "+58",
  "Guiana": "+592",
  "Suriname": "+597",
  "Guiana Francesa": "+594",
  "Costa Rica": "+506",
  "Panamá": "+507",
  "Nicarágua": "+505",
  "Honduras": "+504",
  "El Salvador": "+503",
  "Guatemala": "+502",
  "Belize": "+501",
  "Cuba": "+53",
  "Jamaica": "+1876",
  "Haiti": "+509",
  "República Dominicana": "+1809",
  "Porto Rico": "+1787",
  "Trinidad e Tobago": "+1868",
  "Barbados": "+1246",
  "Bahamas": "+1242",
  "Japão": "+81",
  "China": "+86",
  "Coreia do Sul": "+82",
  "Coreia do Norte": "+850",
  "Mongólia": "+976",
  "Taiwan": "+886",
  "Hong Kong": "+852",
  "Macau": "+853",
  "Singapura": "+65",
  "Malásia": "+60",
  "Tailândia": "+66",
  "Vietnã": "+84",
  "Camboja": "+855",
  "Laos": "+856",
  "Myanmar": "+95",
  "Bangladesh": "+880",
  "Sri Lanka": "+94",
  "Nepal": "+977",
  "Butão": "+975",
  "Paquistão": "+92",
  "Afeganistão": "+93",
  "Irã": "+98",
  "Iraque": "+964",
  "Kuwait": "+965",
  "Arábia Saudita": "+966",
  "Emirados Árabes Unidos": "+971",
  "Qatar": "+974",
  "Bahrain": "+973",
  "Omã": "+968",
  "Iêmen": "+967",
  "Jordânia": "+962",
  "Líbano": "+961",
  "Síria": "+963",
  "Israel": "+972",
  "Palestina": "+970",
  "Turquia": "+90",
  "Geórgia": "+995",
  "Armênia": "+374",
  "Azerbaijão": "+994",
  "Cazaquistão": "+7",
  "Uzbequistão": "+998",
  "Quirguistão": "+996",
  "Tajiquistão": "+992",
  "Turcomenistão": "+993",
  "Filipinas": "+63",
  "Indonésia": "+62",
  "Brunei": "+673",
  "Timor-Leste": "+670",
  "Papua-Nova Guiné": "+675",
  "Fiji": "+679",
  "Vanuatu": "+678",
  "Nova Caledônia": "+687",
  "Ilhas Salomão": "+677",
  "Samoa": "+685",
  "Tonga": "+676",
  "Kiribati": "+686",
  "Tuvalu": "+688",
  "Nauru": "+674",
  "Palau": "+680",
  "Micronésia": "+691",
  "Ilhas Marshall": "+692",
  "Austrália": "+61",
  "Nova Zelândia": "+64",
  "África do Sul": "+27",
  "Nigéria": "+234",
  "Egito": "+20",
  "Marrocos": "+212",
  "Argélia": "+213",
  "Tunísia": "+216",
  "Líbia": "+218",
  "Sudão": "+249",
  "Sudão do Sul": "+211",
  "Etiópia": "+251",
  "Somália": "+252",
  "Djibouti": "+253",
  "Eritreia": "+291",
  "Quênia": "+254",
  "Tanzânia": "+255",
  "Uganda": "+256",
  "Ruanda": "+250",
  "Burundi": "+257",
  "República Democrática do Congo": "+243",
  "República do Congo": "+242",
  "Gabão": "+241",
  "Camarões": "+237",
  "Chade": "+235",
  "República Centro-Africana": "+236",
  "Guiné Equatorial": "+240",
  "São Tomé e Príncipe": "+239",
  "Angola": "+244",
  "Zâmbia": "+260",
  "Zimbábue": "+263",
  "Malawi": "+265",
  "Moçambique": "+258",
  "Namíbia": "+264",
  "Botswana": "+267",
  "Lesoto": "+266",
  "Eswatini": "+268",
  "Madagascar": "+261",
  "Comores": "+269",
  "Maurício": "+230",
  "Seychelles": "+248",
  "Mali": "+223",
  "Burkina Faso": "+226",
  "Níger": "+227",
  "Senegal": "+221",
  "Gâmbia": "+220",
  "Guiné-Bissau": "+245",
  "Guiné": "+224",
  "Serra Leoa": "+232",
  "Libéria": "+231",
  "Costa do Marfim": "+225",
  "Gana": "+233",
  "Togo": "+228",
  "Benin": "+229",
  "Cabo Verde": "+238",
  "Mauritânia": "+222"
};

// Helper function to get country by name
export const getCountryByName = (name: string): Country | undefined => {
  return COUNTRIES.find(country => country.name === name);
};

// Helper function to get country code by country name
export const getCountryCodeByName = (name: string): string => {
  const country = getCountryByName(name);
  return country?.phoneCode || "+55"; // Default to Brazil's code
};

// Helper function to get country by ISO code
export const getCountryByCode = (code: string): Country | undefined => {
  return COUNTRIES.find(country => country.code === code);
};

// Map of browser language codes to country codes
const LANGUAGE_TO_COUNTRY_CODE: Record<string, string> = {
  // Portuguese
  'pt': 'BR',
  'pt-BR': 'BR',
  'pt-PT': 'PT',
  // English
  'en': 'US',
  'en-US': 'US',
  'en-GB': 'GB',
  'en-AU': 'AU',
  'en-CA': 'CA',
  'en-NZ': 'NZ',
  'en-IE': 'IE',
  // Spanish
  'es': 'ES',
  'es-ES': 'ES',
  'es-MX': 'MX',
  'es-AR': 'AR',
  'es-CO': 'CO',
  'es-CL': 'CL',
  'es-PE': 'PE',
  'es-VE': 'VE',
  'es-EC': 'EC',
  'es-GT': 'GT',
  'es-CU': 'CU',
  'es-BO': 'BO',
  'es-DO': 'DO',
  'es-HN': 'HN',
  'es-PY': 'PY',
  'es-SV': 'SV',
  'es-NI': 'NI',
  'es-CR': 'CR',
  'es-PA': 'PA',
  'es-UY': 'UY',
  'es-PR': 'PR',
  // French
  'fr': 'FR',
  'fr-FR': 'FR',
  'fr-CA': 'CA',
  'fr-BE': 'BE',
  'fr-CH': 'CH',
  // German
  'de': 'DE',
  'de-DE': 'DE',
  'de-AT': 'AT',
  'de-CH': 'CH',
  // Italian
  'it': 'IT',
  'it-IT': 'IT',
  'it-CH': 'CH',
  // Japanese
  'ja': 'JP',
  'ja-JP': 'JP',
  // Chinese
  'zh': 'CN',
  'zh-CN': 'CN',
  'zh-TW': 'TW',
  'zh-HK': 'HK',
  // Korean
  'ko': 'KR',
  'ko-KR': 'KR',
  // Russian
  'ru': 'RU',
  'ru-RU': 'RU',
  // Arabic
  'ar': 'SA',
  'ar-SA': 'SA',
  'ar-AE': 'AE',
  'ar-EG': 'EG',
  // Dutch
  'nl': 'NL',
  'nl-NL': 'NL',
  'nl-BE': 'BE',
  // Polish
  'pl': 'PL',
  'pl-PL': 'PL',
  // Turkish
  'tr': 'TR',
  'tr-TR': 'TR',
  // Swedish
  'sv': 'SE',
  'sv-SE': 'SE',
  // Norwegian
  'no': 'NO',
  'nb': 'NO',
  'nn': 'NO',
  // Danish
  'da': 'DK',
  'da-DK': 'DK',
  // Finnish
  'fi': 'FI',
  'fi-FI': 'FI',
  // Greek
  'el': 'GR',
  'el-GR': 'GR',
  // Czech
  'cs': 'CZ',
  'cs-CZ': 'CZ',
  // Hungarian
  'hu': 'HU',
  'hu-HU': 'HU',
  // Romanian
  'ro': 'RO',
  'ro-RO': 'RO',
  // Ukrainian
  'uk': 'UA',
  'uk-UA': 'UA',
  // Hindi
  'hi': 'IN',
  'hi-IN': 'IN',
  // Thai
  'th': 'TH',
  'th-TH': 'TH',
  // Vietnamese
  'vi': 'VN',
  'vi-VN': 'VN',
  // Indonesian
  'id': 'ID',
  'id-ID': 'ID',
  // Malay
  'ms': 'MY',
  'ms-MY': 'MY',
  // Filipino
  'fil': 'PH',
  'tl': 'PH',
};

/**
 * Get the default country name based on the browser's language setting.
 * Falls back to "Estados Unidos" (United States) if no match is found.
 */
export const getDefaultCountryByBrowserLanguage = (): string => {
  // Get browser language
  const browserLanguage = navigator.language || (navigator as any).userLanguage || 'en-US';
  
  // Try exact match first
  let countryCode = LANGUAGE_TO_COUNTRY_CODE[browserLanguage];
  
  // If no exact match, try the base language (e.g., 'en' from 'en-US')
  if (!countryCode) {
    const baseLanguage = browserLanguage.split('-')[0];
    countryCode = LANGUAGE_TO_COUNTRY_CODE[baseLanguage];
  }
  
  // Default to US if still no match
  if (!countryCode) {
    countryCode = 'US';
  }
  
  // Find the country by code and return its name
  const country = getCountryByCode(countryCode);
  return country?.name || 'Estados Unidos';
};
